import { createStore, applyMiddleware } from 'redux';

import createSentryMiddleware from 'redux-sentry-middleware';
import { composeWithDevTools } from 'redux-devtools-extension';
// import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';

import thunk from 'redux-thunk';
import api from '../middleware/api';
import { aiApi } from 'new/modules/ai/state/aiApi';
import { capsulesApi } from 'new/stores/capsules/capsules.api';
import { capsulesListenerMiddleware } from 'new/stores/capsules/capsules.listeners';
import { metricsApi } from 'new/stores/metrics/metrics.api';
import { adminOrgsApi } from 'new/stores/adminOrgs/adminOrgs.api';
import { INSERT_TYPE_FILE_UPLOAD } from '../constants/dataMapConstants';
import { EDIT_DATA_MAP_SELECTED_FILE } from '../constants/actionTypes';

import rootReducer from '../reducers/index';
import AnalyticsUtils from '../lib/AnalyticsUtils';
import * as Sentry from '@sentry/react';

//NOTE: The flag below should only be used locally to validate if redux implementation is not mutating state incorrectly.
// Do not set it on deployed sites otherwise page interaction will slow down drastically.
const REDUX_DEV_TEST_MODE_ENABLED = false;

const getSentryMiddleware = () => {
  let sentry = AnalyticsUtils.getSentry();
  if (sentry) {
    return createSentryMiddleware(sentry, {
      stateTransformer: (state) => {
        return {};
      },
    });
  } else {
    return null;
  }
};

const devToolsOptions = {
  trace: true,
  traceLimit: 10,
  actionSanitizer: (action) => {
    return action.type === EDIT_DATA_MAP_SELECTED_FILE
      ? { ...action, payload: '(possibly large payload)' }
      : action;
  },
  stateSanitizer: (state) => {
    return state.dataMapEditForm && state.dataMapEditForm.insertType === INSERT_TYPE_FILE_UPLOAD
      ? {
          ...state,
          dataMapEditForm: {
            ...state.dataMapEditForm,
            dataMapObj: {
              ...state.dataMapEditForm.dataMapObj,
              data_map: '(possibly large array of objects)',
            },
          },
        }
      : state;
  },
};
const composeEnhancers = composeWithDevTools(devToolsOptions);

const getImmutableTester = () => {
  const { default: immutableStateInvariant } = require('redux-immutable-state-invariant');

  return immutableStateInvariant({
    ignore: ['schemaEditor.annotations.sa', 'schemaEditor.transforms.tx'],
  });
};

const getMiddleWares = () => {
  let ravenMiddleware = getSentryMiddleware();
  let middlewares = [
    thunk,
    aiApi.middleware,
    capsulesApi.middleware,
    metricsApi.middleware,
    capsulesListenerMiddleware.middleware,
    adminOrgsApi.middleware,
    api,
  ];

  if (ravenMiddleware) {
    middlewares.push(ravenMiddleware);
  }

  if (REDUX_DEV_TEST_MODE_ENABLED === true) {
    let immutableTester = getImmutableTester();
    middlewares.unshift(immutableTester);
  }

  return middlewares;
};

export default function configureStore(initialState) {
  let middlewares = getMiddleWares();
  return createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(...middlewares), Sentry.createReduxEnhancer()),
  );
}
